export default "__VITE_ASSET__BvLFGuCp__"